<template>
<v-card outlined class="bg_none">
    <v-card-title class="text-primary text-center text-h5 font-weight-black">INFORMACIÓN COMPLETA DEL OINK</v-card-title>
    <v-divider></v-divider>
    <v-expansion-panels v-if="result" hover accordion flat class="pa-5">
        <v-expansion-panel v-for="(data,i) in result" :key="i" class="elevation-0 bg_none accordeon">
            <v-expansion-panel-header>
                <span>
                    <v-icon color="success" small v-if="data.failed_calls===0">mdi-circle</v-icon>
                    <v-icon color="warning" small v-if="data.failed_calls>0">mdi-circle</v-icon>
                    {{data.detail_name}}
                </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>

                <v-data-table class="mt-5 bg_none border" light v-if="data.status.length > 0" :headers="headers" :items="data.status" hide-default-footer>
                    <template v-slot:[`item.status_code`]="{ item }">
                        <span>
                            <v-chip color="success" small v-if="item.status_code===200" dark>{{item.status_code}}</v-chip>
                            <v-chip color="warning" small v-if="item.status_code===300" light>{{item.status_code}}</v-chip>
                            <v-chip color="error" small v-if="item.status_code===500" dark>{{item.status_code}}</v-chip>
                        </span>
                    </template>
                    <template v-slot:[`item.status_date`]="{ item }">
                        <span>
                            {{getDate(item.status_date)}}
                        </span>
                    </template>
                </v-data-table>

            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</v-card>
</template>

<script>
import ApiService from '../../../libs/apiService';
export default {
    name: 'General',
    props: ['id'],
    data() {
        return {
            result: null,
            loading: false,
            headers: [{
                    text: "Estado",
                    value: "status_code",
                    sortable: false,
                    align: "left"
                },
                {
                    text: "Fecha",
                    value: "status_date",
                    sortable: false,
                    align: "left"
                },
                {
                    text: "Mensaje",
                    value: "status_message",
                    sortable: false,
                    align: "left"
                }
            ]
        }
    },
    methods: {
        async getStatus() {
            this.loading = true;
            const apiService = new ApiService();
            const req = {
                piggy_bank_id: this.id
            };
            apiService.post('/piggybank/piggybankstatuslist', req, true).then((res) => {
                this.loading = false;
                if (res) {
                    const data = JSON.parse(res);
                    this.result = data;
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
            });
        },
        getDate(d) {
            const date = d.split('T');
            return `${date[0]}, ${this.getTime(date[1])}`;
        },
        getTime(time) {
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
                time = time.slice(1); // Remove full string match value
                time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join('');
        }
    },
    mounted() {
        setTimeout(() => {
            this.getStatus();
        }, 100);
    },
}
</script>
